module.exports = __webpack_public_path__ + "img/grid-hide.b694d023.svg";